import { useState, useCallback } from 'react';
import { useGetIsMounted } from './useGetIsMounted.js';

/**
 * useSafeSetState
 * @description set state but ignores if component has already unmounted
 * @see {@link https://rooks.vercel.app/docs/useSafeSetState}
 */
function useSafeSetState(initialState) {
    const [state, setState] = useState(initialState);
    const getIsMounted = useGetIsMounted();
    const safeSetState = useCallback((newState) => {
        if (getIsMounted()) {
            setState(newState);
        }
    }, [getIsMounted]);
    return [state, safeSetState];
}

export { useSafeSetState };
